export default __webpack_public_path__ + "static/media/2020_Properties_Assets-23.bb9f1188.svg";